import { ObjectType } from 'api/pushes';
import { SourceType } from 'components/organisms/tasks/fields';
import { unreachable } from 'utils/unreachable';

export enum FilterGroupType {
  Task = SourceType.Task,
  Project = SourceType.Project,
  User = SourceType.User,
  Phase = SourceType.Phase,
  Timesheet = SourceType.Timesheet,
  Role = SourceType.Role,
  StarMeta = SourceType.StarMeta,
}

export const sourceTypeToFieldGroupType = (st: SourceType) => {
  switch (st) {
    case SourceType.Project:
      return FilterGroupType.Project;
    case SourceType.Task:
    case undefined:
      return FilterGroupType.Task;
    case SourceType.User:
      return FilterGroupType.User;
    case SourceType.Phase:
      return FilterGroupType.Phase;
    case SourceType.Timesheet:
      return FilterGroupType.Timesheet;
    default:
      return unreachable(st as never);
  }
};

export const objectTypeToFieldGroupType = (st: ObjectType) => {
  switch (st) {
    case ObjectType.Project:
      return FilterGroupType.Project;
    case ObjectType.Task:
    case undefined:
      return FilterGroupType.Task;
    // hack way, sry
    case ObjectType.User:
    case 'USERS':
      return FilterGroupType.User;
    case ObjectType.ProjectPhase:
      return FilterGroupType.Phase;

    default:
      return unreachable(st as never);
  }
};
